export default "__VITE_ASSET__Col_KYkV__";